import Validator from "js-object-validation";
import { message } from "../common";

export const addTopic = (data) => {
  const validations = {
    topic: {
      required: true,
    },
    description: {
      required: true,
    },
    moduleId: {
      required: true,
    },
  };
  // Error messages
  const messages = {
    topic: {
      required: message.Required.replace(":item", "topic name"),
    },
    description: {
      required: message.Required.replace(":item", "topic description"),
    },
    moduleId: {
      required: message.Required.replace(":item", "Module"),
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
